import React, { useRef, useEffect, useState } from 'react'
import './charts.scss'
import { select, axisBottom, axisLeft, scaleLinear, scaleBand } from 'd3'

import * as d3 from 'd3'

function Charts() {
  const [data, setData] = useState([
    { category: 'Jan', quantity1: 94, quantity2: 60, quantity3: 34 },
    { category: 'Feb', quantity1: 60, quantity2: 20, quantity3: 40 },
    { category: 'Mar', quantity1: 20, quantity2: 16, quantity3: 4 },
    { category: 'Apr', quantity1: 76, quantity2: 60, quantity3: 16 },
    { category: 'May', quantity1: 40, quantity2: 30, quantity3: 10 },
    { category: 'June', quantity1: 80, quantity2: 60, quantity3: 20 },
    { category: 'Jul', quantity1: 0 },
    { category: 'Aug', quantity1: 0 },
    { category: 'Sep', quantity1: 0 },
    { category: 'Oct', quantity1: 0 },
    { category: 'Nov', quantity1: 0 },
    { category: 'Dec', quantity1: 0 },
  ])

  const [active, setActive] = useState([
    { category: 'Jan', quantity2: 60 },
    { category: 'Feb', quantity2: 20 },
    { category: 'Mar', quantity2: 16 },
    { category: 'Apr', quantity2: 60 },
    { category: 'May', quantity2: 30 },
    { category: 'June', quantity2: 60 },
    { category: 'Jul', quantity2: 0 },
    { category: 'Aug', quantity2: 0 },
    { category: 'Sep', quantity2: 0 },
    { category: 'Oct', quantity2: 0 },
    { category: 'Nov', quantity2: 0 },
    { category: 'Dec', quantity2: 0 },
  ])
  const [inactive, setInactive] = useState([
    { category: 'Jan', quantity3: 34 },
    { category: 'Feb', quantity3: 40 },
    { category: 'Mar', quantity3: 4 },
    { category: 'Apr', quantity3: 16 },
    { category: 'May', quantity3: 10 },
    { category: 'June', quantity3: 20 },
    { category: 'Jul', quantity3: 0 },
    { category: 'Aug', quantity3: 0 },
    { category: 'Sep', quantity3: 0 },
    { category: 'Oct', quantity3: 0 },
    { category: 'Nov', quantity3: 0 },
    { category: 'Dec', quantity3: 0 },
  ])

  const svgRef = useRef()
  useEffect(() => {
    const svg = select(svgRef.current)

    const xScale = scaleBand()
      .domain(inactive.map((value, index) => index))
      .range([0, 700])
      .padding(0.8)

    const yScale = scaleLinear().domain([0, 100]).range([350, 100])

    const xAxis = axisBottom(xScale)
      .ticks(inactive.length)
      .tickFormat((i) => inactive[i].category)
      .tickPadding(20)
      .tickSizeInner(0)

    svg.select('.x-axis').style('transform', 'translateY(350px)').call(xAxis)

    const yAxis = axisLeft(yScale).tickPadding(10).tickSizeInner(0)
    svg.select('.y-axis').style('transform', 'translateX(0px)').call(yAxis)

    const yAxisGrid = axisLeft(yScale).tickSize(700).tickFormat('').ticks(10)
    svg
      .select('.y_grid')
      .style('transform', 'translateX(700px)')
      .style('stroke-dasharray', '5 5')
      .call(yAxisGrid)

    //tooltip
    const tooldiv = d3
      .select('.toolTip')
      .append('div')
      .style('visibility', 'hidden')
      .style('position', 'absolute')
      .style('background-color', '#F5F5F5')
      .style('display', 'flex')

    svg
      .selectAll('.bar')
      .data(inactive)
      .join('rect')
      .attr('class', 'bar')

      .style('transform', 'scale(1, -1)')
      .attr('x', (value, index) => xScale(index))
      .attr('y', -350)
      .attr('width', xScale.bandwidth())
      .on('mouseover', (e, value) => {

        tooldiv
          .style('visibility', 'visible')
          .text(`${value.category} Inactive: ${value.quantity3}`)
          .style('font', ' normal normal 600 14px/21px Poppins')
          .style('width', '90px')
          .style('height', '40px')
          .style('display', 'inline')
          .style('padding', '10px')
          .style('border-radius', '10px')
          .style('box-shadow', '10px #00000005')
      })
      .on('mousemove', (e, value) => {
        tooldiv
          .style('top', e.pageY - 400 + 'px')
          .style('left', e.pageX - 250 + 'px')
      })
      .on('mouseout', () => {
        tooldiv.style('visibility', 'hidden')
      })
      .transition()
      .attr('fill', '#FFAD44')
      .attr('height', (value) => yScale(0) - yScale(value.quantity3))
  }, [inactive])

  useEffect(() => {
    const svg = select(svgRef.current)

    const xScale = scaleBand()
      .domain(active.map((value, index) => index))
      .range([0, 700])
      .padding(0.8)

    const yScale = scaleLinear().domain([0, 100]).range([350, 100])
    svg.select('.y_scale').call(yScale)

    const xAxis = axisBottom(xScale)
      .ticks(active.length)
      .tickFormat((i) => active[i].category)
      .tickPadding(20)
      .tickSizeInner(0)

    svg.select('.x-axis').style('transform', 'translateY(350px)').call(xAxis)

    const yAxis = axisLeft(yScale).tickPadding(10).tickSizeInner(0)
    svg.select('.y-axis').style('transform', 'translateX(0px)').call(yAxis)

    const yAxisGrid = axisLeft(yScale).tickSize(700).tickFormat('').ticks(10)
    svg
      .select('.y_grid')
      .style('transform', 'translateX(700px)')
      .style('stroke-dasharray', '5 5')
      .call(yAxisGrid)
    const tooldiv = d3
      .select('.toolTip')
      .append('div')
      .style('visibility', 'hidden')
      .style('position', 'absolute')
      .style('background-color', '#F5F5F5')
      .style('display', 'flex')

    svg
      .selectAll('.bar')
      .data(active)
      .join('rect')
      .attr('class', 'bar')
      .style('transform', 'scale(1, -1)')
      .attr('x', (value, index) => xScale(index))
      .attr('y', -350)
      .attr('width', xScale.bandwidth())
      .on('mouseover', (e, value) => {

        tooldiv
          .style('visibility', 'visible')
          .text(`${value.category}  Active: ${value.quantity2}`)
          .style('font', ' normal normal 600 14px/21px Poppins')
          .style('width', '75px')
          .style('height', '40px')
          .style('display', 'inline')
          .style('padding', '10px')
          .style('border-radius', '10px')
          .style('box-shadow', '10px #00000005')
      })
      .on('mousemove', (e, value) => {
        tooldiv
          .style('top', e.pageY - 400 + 'px')
          .style('left', e.pageX - 250 + 'px')
      })
      .on('mouseout', () => {
        tooldiv.style('visibility', 'hidden')
      })
      .transition()
      .attr('fill', '#25C997')
      .attr('height', (value) => yScale(0) - yScale(value.quantity2))
  }, [active])

  useEffect(() => {
    const svg = select(svgRef.current)

    const xScale = scaleBand()
      .domain(data.map((value, index) => index))
      .range([0, 700])
      .padding(0.8)

    const x1Scale = scaleBand()

    const yScale = scaleLinear().domain([0, 100]).range([350, 100])

    const xAxis = axisBottom(xScale)
      .ticks(data.length)
      .tickFormat((i) => data[i].category)
      .tickPadding(20)
      .tickSizeInner(0)

    svg.select('.x-axis').style('transform', 'translateY(350px)').call(xAxis)

    const yAxis = axisLeft(yScale).tickPadding(10).tickSizeInner(0)
    svg.select('.y-axis').style('transform', 'translateX(0px)').call(yAxis)

    const yAxisGrid = axisLeft(yScale).tickSize(700).tickFormat('').ticks(10)
    svg
      .select('.y_grid')
      .style('transform', 'translateX(700px)')
      .style('stroke-dasharray', '5 5')
      .call(yAxisGrid)

    const tooldiv = d3
      .select('.chartDisplay')
      .append('div')
      .attr("class" , "")
      .style('visibility', 'hidden')
      .style('position', 'absolute')
      .style('background-color', '#F5F5F5')
      .style('display', 'flex')

    svg
      .selectAll('.bar')
      .data(data)
      .join('rect')
      .attr('class', 'bar')
      .style('transform', 'scale(1, -1)')
      .attr('x', (value, index) => xScale(index))
      .attr('y', -350)
      .attr('width', xScale.bandwidth())
      .on('mouseover', (e, value) => {

        tooldiv
          .style('visibility', 'visible')
          .text(`${value.category}  All: ${value.quantity1}`)
          .style('font', ' normal normal 600 14px/21px Poppins')
          .style('width', '75px')
          .style('height', '40px')
          .style('display', 'inline')
          .style('padding', '10px')
          .style('border-radius', '10px')
          .style('box-shadow', '10px #00000005')
      })
      .on('mousemove', (e, value) => {
        tooldiv
          .style('top', e.pageY - 400 + 'px')
          .style('left', e.pageX - 250 + 'px')
      })
      .on('mouseout', () => {
        tooldiv.style('visibility', 'hidden')
      })
      .transition()
      .attr('fill', '#F64E60')
      .attr('height', (value) => yScale(0) - yScale(value.quantity1))
  }, [data])

  const handleSelectCurrentChart = (e) => {
    document.querySelector('.active-dots')?.classList?.remove('active-dots')
    const isParentLiTag = e.target.offsetParent.className.includes(
      'chart-ctrls',
    )

    if (isParentLiTag) {
      e.target.offsetParent.classList.add('active-dots')
    } else {
      e.target.classList.add('active-dots')
    }
  }

  return (
    <>
      <div className="userCharts">
        <ul>
          <li
            className="chart-ctrls active-dots"
            id="chartL1"
            onClick={(e) => {
              handleSelectCurrentChart(e)
              setData(data.map((value) => value))
            }}
          >
            <label>All Customers</label>
            <p>Total</p>
          </li>
          <li
            className="chart-ctrls"
            id="chartL2"
            onClick={(e) => {
              handleSelectCurrentChart(e)
              setActive(active.map((value) => value))
            }}
          >
            <label>Active Customers</label>
            <p>Total Active</p>
          </li>
          <li
            className="chart-ctrls"
            id="chartL3"
            onClick={(e) => {
              handleSelectCurrentChart(e)
              setInactive(inactive.map((value) => value))
            }}
          >
            <label>Inactive Customers</label>
            <p>Total Inactive</p>
          </li>
        </ul>

        <div className="chartDisplay">
          <div className="toolTip"></div>
          <svg className="svg" ref={svgRef}>
            <g className="x-axis"> </g>

            <g className="y_grid"></g>
            <g className="y-axis" />
          </svg>
        </div>
      </div>
    </>
  )
}

export default Charts
